import { TaskModel } from "src/@allxs/model/task/task.model";
import { WebOrderModel } from "@app/core/models/weborder/weborder.model";


export class WebTaskOrderModel {
    public order: WebOrderModel;
    public task: TaskModel;
}